<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Patient Name (Patient ID)</th>
                        <th>Gender &amp; Age</th>
                        <th>Mobile No</th>
                        <th>Admission No</th>
                        <th>First Consultation Date</th>
                        <th>Consultant</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in patientList" :key="i">
                        <td>{{ item.patient_name }} ({{ item.patient_serial_no }})</td>
                        <td>{{ formatGenderAge(item) }}</td>
                        <td>{{ item.patient_mobile_no }}</td>
                        <td>{{ item.admission_no }}</td>
                        <td>{{ item.admission_date }}</td>
                        <td>{{ item.consultant_name }}</td>
                        <td>
                            <button @click="onClickToRx(item)" class="btn btn-secondary btn-sm">
                                <i class="fas fa-prescription"></i>
                                Rx
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-if="!patientList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { convertToTitleCase } from '@/services/utils/global';

const props = defineProps({
    patientList: {
        type: Array,
        default: () => []
    }
})

const route = useRoute();
const router = useRouter();

const formatGenderAge = (item) => {
    const gender = item.patient_gender ? convertToTitleCase(item.patient_gender) : '';
    if (!item.patient_age) return gender;
    if (!gender) return item.patient_age;
    return gender + ' - ' + item.patient_age;
}

const onClickToRx = (item) => {
    router.push({
        name: 'dental-service',
        params: {
            ...route.params,
            serviceId: item.service_general_id
        },
        query: {
            ...route.query,
            general_id: item.general_id,
            ipd_register_id: item.ipd_register_id,
            contact_id: item.ipd_contact_profile_id,
            service_status: 'ongoing_service',
            back_url: encodeURIComponent(route.fullPath)
        }
    })
}
</script>

<style scoped>
.card-height {
    min-height: 200px;
}
</style>
